class MenuDrawer extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-menu-toggle]');
    this.panel = this.querySelector('[data-menu-panel]');
    if (!this.button || !this.panel) return;
    this.button.addEventListener('click', () => this.toggle());
    this.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.close();
    });
  }
  toggle() {
    const isOpen = this.button.getAttribute('aria-expanded') === 'true';
    isOpen ? this.close() : this.open();
  }
  open() {
    this.button.setAttribute('aria-expanded', 'true');
    this.button.textContent = 'Close';
    this.button.setAttribute('aria-label', 'Close menu');
    this.panel.hidden = false;
    document.body.classList.add('menu-open');
    const firstLink = this.panel.querySelector('a');
    if (firstLink) firstLink.focus();
  }
  close() {
    this.button.setAttribute('aria-expanded', 'false');
    this.button.textContent = 'Menu';
    this.button.setAttribute('aria-label', 'Open menu');
    this.panel.hidden = true;
    document.body.classList.remove('menu-open');
    this.button.focus();
  }
}
customElements.define('menu-drawer', MenuDrawer);

class ProductRecommendations extends HTMLElement {
  connectedCallback() {
    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver((entries) => {
        if (!entries[0].isIntersecting) return;
        this.observer.disconnect();
        this.load();
      }, { rootMargin: '300px 0px' });
      this.observer.observe(this);
      return;
    }
    this.load();
  }
  load() {
    const url = this.dataset.url;
    if (!url) return;
    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        const recommendations = html.querySelector('product-recommendations');
        if (recommendations && recommendations.innerHTML.trim()) this.innerHTML = recommendations.innerHTML;
      })
      .catch(() => {});
  }
}
customElements.define('product-recommendations', ProductRecommendations);

class QuantityInput extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('input');
    this.querySelectorAll('button').forEach((button) => {
      button.addEventListener('click', () => {
        const current = Number(this.input.value || 1);
        const next = button.name === 'plus' ? current + 1 : Math.max(1, current - 1);
        this.input.value = next;
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }
}
customElements.define('quantity-input', QuantityInput);

class BogoReminder extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('[data-bogo-dialog]');
    this.heading = this.querySelector('[data-bogo-dialog-heading]');
    this.continueButton = this.querySelector('[data-bogo-continue]');
    this.checkoutButton = document.querySelector('[data-cart-checkout]');
    this.eligibleQuantity = Number(this.dataset.eligibleQuantity || 0);
    this.unpaired = this.dataset.unpaired === '1';
    this.allowCheckout = false;
    this.checkoutPending = false;

    if (!this.dialog) return;

    this.querySelector('[data-bogo-close]')?.addEventListener('click', () => this.close());
    this.continueButton?.addEventListener('click', () => this.continue());
    this.dialog.addEventListener('click', (event) => {
      if (event.target === this.dialog) this.close();
    });

    if (this.checkoutButton) {
      this.checkoutButton.addEventListener('click', (event) => {
        if (this.allowCheckout || !this.unpaired) return;
        event.preventDefault();
        this.checkoutPending = true;
        this.open('checkout');
      });
    }

    const url = new URL(window.location.href);
    if (url.searchParams.get('bogo') === 'added') {
      url.searchParams.delete('bogo');
      window.history.replaceState({}, '', url);
      if (this.unpaired) this.open('added');
    }
  }

  open(reason) {
    if (reason === 'checkout') {
      if (this.heading) this.heading.textContent = "Don't miss your free item";
      if (this.continueButton) this.continueButton.textContent = 'Continue to checkout';
    } else {
      if (this.heading) this.heading.textContent = 'Your free item is waiting';
      if (this.continueButton) this.continueButton.textContent = 'Not now';
    }
    if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
    else this.dialog.setAttribute('open', '');
  }

  close() {
    this.checkoutPending = false;
    if (typeof this.dialog.close === 'function') this.dialog.close();
    else this.dialog.removeAttribute('open');
  }

  continue() {
    const shouldCheckout = this.checkoutPending;
    this.checkoutPending = false;
    if (typeof this.dialog.close === 'function') this.dialog.close();
    else this.dialog.removeAttribute('open');
    if (!shouldCheckout || !this.checkoutButton) return;
    this.allowCheckout = true;
    this.checkoutButton.click();
  }
}
customElements.define('bogo-reminder', BogoReminder);

document.querySelectorAll('[data-variant-select]').forEach((select) => {
  select.addEventListener('change', () => {
    const option = select.options[select.selectedIndex];
    const form = select.closest('form');
    const idInput = form && form.querySelector('[name="id"]');
    if (idInput) idInput.value = option.value;
    document.querySelectorAll('[data-product-price]').forEach((price) => {
      if (option.dataset.price) price.textContent = option.dataset.price;
    });
    document.querySelectorAll(`[data-product-submit="${form.id}"]`).forEach((button) => {
      button.disabled = option.dataset.available !== 'true';
      button.textContent = option.dataset.available === 'true' ? `${button.dataset.addLabel} ${option.dataset.price}` : button.dataset.soldLabel;
    });
    document.querySelectorAll('[data-product-availability]').forEach((status) => {
      status.textContent = option.dataset.available === 'true' ? 'Available' : 'Sold out';
      status.dataset.available = option.dataset.available;
    });
    const url = new URL(window.location.href);
    url.searchParams.set('variant', option.value);
    window.history.replaceState({}, '', url);
  });
});

document.querySelectorAll('.product-form').forEach((form) => {
  form.addEventListener('submit', (event) => {
    if (form.dataset.submitting === 'true') {
      event.preventDefault();
      return;
    }
    form.dataset.submitting = 'true';
    document.querySelectorAll(`[data-product-submit="${form.id}"]`).forEach((button) => {
      button.setAttribute('aria-disabled', 'true');
      button.textContent = 'Adding…';
    });
  });
});
